export default "<template>\n  <MainLayout />\n</template>\n<script setup>\nimport MainLayout from \"./views/MainView.vue\";\n</script>";